﻿// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AuthenticationManager {
    public static initialise(): void {
        $(window).ajaxComplete(AuthenticationManager._onAjaxComplete);
    }

    private static _onAjaxComplete(
        this: Document,
        e: JQuery.TriggeredEvent,
        xhr: JQuery.jqXHR,
    ): void {
        const header: string = xhr.getResponseHeader(`IsAuthenticated`);

        if (header) {
            const isAuthenticated: boolean = header.toLowerCase() === `true`;

            if (!isAuthenticated) {
                this.location.reload();
            }
        }
    }
}
